import dynamic from "next/dynamic";

export const DynamicLayoutWidget012 = dynamic(
  () => import("./LayoutWidget012"),
  {
    suspense: true,
  }
);
